/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable array-callback-return */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
import axios from "axios";

//import SameCodeItem from '../../components/search/SameCodeItem'
//import GenreCodeItem from '../../components/search/GenreCodeItem'
import TagCodeItem from "../../components/search/TagCodeItem";

class TagTagCode extends Component {
  state = {
    more: false,
  };
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;
    this._getData();
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };

  _getData = async () => {
    const result = await this._getDataApi();

    const intReturn = result.data[0].intReturn;
    const tagList = result.data[0].listData;

    if (intReturn === 0) {
      if (this._isMounted) {
        this.setState({
          tagList,
        });
      }
    }
  };

  _getDataApi = () => {
    const { apiUrl } = this.props;

    return axios(apiUrl + "/tagTagCode")
      .then((response) => response)
      .catch((error) => {
        //console.log('동시방역 코드 오류')
      });
  };
  _renderItem = () => {
    const { tagList, more } = this.state;
    const { tagCodeAdd, tagCodeDel, init, chkCode } = this.props.childProps;
    const list = tagList.map((item, index) => {
      if (more) {
        return (
          <TagCodeItem
            key={index}
            tagCode={item.tagCode}
            tagName={item.tagName}
            tagCodeAdd={tagCodeAdd}
            tagCodeDel={tagCodeDel}
            init={init}
            chkCode={chkCode}
          />
        );
      } else {
        if (index < 4) {
          return (
            <TagCodeItem
              key={index}
              tagCode={item.tagCode}
              tagName={item.tagName}
              tagCodeAdd={tagCodeAdd}
              tagCodeDel={tagCodeDel}
              init={init}
              chkCode={chkCode}
            />
          );
        }
      }
    });

    return list;
  };
  _toggleMore = () => {
    const { more } = this.state;

    this.setState({
      more: !more,
    });
  };
  render() {
    const { tagList, more } = this.state;
    return (
      <Fragment>
        <div>
          <dl>
            <dt>태그</dt>
            {tagList ? this._renderItem() : null}
            {/*
                        <dd>
                            <div className="chek_group">
                                <input name="선택" id="checkbox_1" type="checkbox" value="" className="checkbox_img"/><label htmlFor="checkbox_1">2020년 4분기</label>
                            </div>
                        </dd>
                        <dd>
                            <div className="chek_group">
                                <input name="선택" id="checkbox_2" type="checkbox" value="" className="checkbox_img"/><label htmlFor="checkbox_2">2020년 3분기</label>
                            </div>
                        </dd>
                        <dd>
                            <div className="chek_group">
                                <input name="선택" id="checkbox_3" type="checkbox" value="" className="checkbox_img"/><label htmlFor="checkbox_3">2020년 2분기</label>
                            </div>
                        </dd>
                        <dd>
                            <div className="chek_group">
                                <input name="선택" id="checkbox_1" type="checkbox" value="" className="checkbox_img"/><label htmlFor="checkbox_1">2020년 1분기</label>
                            </div>
                        </dd>
                        */}
          </dl>
          {more ? (
            <div className="vod_list_more">
              <a style={{ cursor: "pointer" }} onClick={this._toggleMore}>
                <img src="img/vod/more2.png" />
                간략히보기
              </a>
            </div>
          ) : (
            <div className="vod_list_more">
              <a style={{ cursor: "pointer" }} onClick={this._toggleMore}>
                <img src="img/vod/more.png" />
                더보기
              </a>
            </div>
          )}
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(TagTagCode));
